<template>
	<el-main class="userdetail">
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/author' }">账号管理</el-breadcrumb-item>
				<el-breadcrumb-item>查看</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="header">
			<div class="header-info">
				<h1>{{ `${form.realname} ${form.en_name}` }}</h1>
				<p style="font-size: 20px; font-weight: 550;">{{ `${form.department.short_name} -
					${form.position.en_name}` }}
				</p>
				<p>{{ `${form.nickname}` }}</p>
			</div>
		</div>

		<div class="base1">
			<h3 class="ntitle" v-if="authorType == '1'">选择职位</h3>
			<h3 class="ntitle" v-if="authorType == '2'">查阅范围</h3>
			<h3 class="ntitle" v-if="authorType == '3'">直属上下级</h3>
			<h3 class="ntitle" v-if="authorType == '4'">办公用品</h3>
			<el-form ref="form" :model="form" label-width="120px" label-position="left">
				<template v-if="authorType == '1'">
					<el-form-item label="职位:" prop="level">
						<el-col :span="20">
							<el-select v-model="form.level" placeholder="请选择" style="margin-right: 0; width: 400px;"
								clearable filterable>
								<el-option :label="`${v.role_name}`" :value="v.id" v-for="(v, i) in roleList"
									:key="`lv_${i}`"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
				</template>

				<template v-if="authorType == '2'">
					<el-form-item label="基本范围:" prop="access">
						<el-col :span="20">
							<el-radio-group v-model="form.access">
								<el-radio label="1">自己/下属</el-radio>
								<el-radio label="2">全部</el-radio>
							</el-radio-group>
						</el-col>
					</el-form-item>

					<el-form-item label="协助查阅项目:" prop="access">
						<el-col :span="20">
							<div v-for="(item, index) in whiteList" :key="`white_${index}`" class="whitelist">
								<span>{{ item.ncbn_str }}</span>
								<span class="whitelist_del">
									<el-button type="danger" icon="el-icon-delete" circle
										@click="deleteWhite(item.id, item.type, item.ncbn_str)"></el-button>
								</span>
							</div>
						</el-col>
					</el-form-item>
					<el-button type='primary' icon="el-icon-plus" style="margin-left: 120px;"
						@click="showProject">新增</el-button>

				</template>

				<template v-if="authorType == '3'">
					<el-form-item label="直属领导:" prop="leader">
						<el-col :span="20">
							<el-select v-model="form.leader" placeholder="请选择" style="margin-right: 0; width: 400px;"
								clearable filterable>
								<el-option :label="`${v.realname} ${v.en_name}`" :value="v.id"
									v-for="(v, i) in userList" :key="i"></el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="下属:" prop="subordinate">
						<ul class="authorlist" style="padding: 32px 0 0;">
							<li v-for="(item, index) in form.subordinate" :key="`sub_${index}`">
								<div class="subbtn" @click="toPersonFn(item.id)">
									{{ item.realname }} {{ item.en_name }}
								</div>
							</li>
						</ul>
					</el-form-item>
				</template>

				<template v-if="authorType == '4'">
					<el-form-item label="" prop="office_list">
						<el-col :span="20">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
								placeholder="请输入领取的办公用品，电脑或U盘等，没有可不填" v-model="form.office_list">
							</el-input>
						</el-col>
					</el-form-item>
				</template>

				<el-form-item label="" style="margin-top: 50px;">
					<el-col>
						<el-button @click="resetForm('form')">取消</el-button>
						<el-button type="primary" @click="submitForm('form')">确定</el-button>
					</el-col>
				</el-form-item>
			</el-form>
		</div>

		<el-dialog title="新增协助查阅" :visible.sync="projectShow" width="650px">
			<el-form ref="projectForm" :model="projectForm" label-width="150px" label-position="left">
				<el-form-item label="选择客户：">
					<el-col :span="24">
						<el-select v-model="projectForm.client_id" placeholder="" style="margin-right: 0; width: 100%;"
							filterable @change="clientChange">
							<el-option :label="v.company" :value="v.id" v-for="(v, i) in clientList"
								:key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="选择品牌：">
					<el-col :span="24">
						<el-select v-model="projectForm.barnd_list" multiple collapse-tags placeholder=""
							style="margin-right: 0; width: 100%;" filterable @change="brandChange">
							<el-option :label="v.brand" :value="v.id" v-for="(v, i) in brandList" :key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="选择项目：">
					<el-col :span="24">
						<el-select v-model="projectForm.project_list" multiple collapse-tags placeholder=""
							style="margin-right: 0; width: 100%;" filterable @change="projectChange">
							<el-option :label="`${v.contract_no}-${v.contract_name}`" :value="v.id"
								v-for="(v, i) in projectList" :key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<!-- <div style="text-align: center;">注：关联项目后不能修改</div> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelProjectId">取 消</el-button>
				<el-button type="primary" @click="confirmProjectId">确 认</el-button>
			</span>
		</el-dialog>

		<el-dialog title="删除协助查阅项目" :visible.sync="deleteShow" width="650px">
			<ul class="aul" style="padding:0">
				<li>
					<span>{{ tempDelete.ncbn_str }}</span>
				</li>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="deleteShow = false">取 消</el-button>
				<el-button type="primary" @click="handleDelete()">确 定</el-button>
			</span>
		</el-dialog>
	</el-main>
</template>

<script>
import * as api from '@/api'
export default {
	name: 'authorBuild',
	data() {
		return {
			nodeLimtList: [],
			userList: [],
			departList: [],
			positionList: [],
			whiteList: [],//白名单
			roleList: [],
			// levelList: [
			// 	{ levelName: 'HR', lv: '2' },
			// 	{ levelName: 'HRM', lv: '8' },
			// 	{ levelName: 'AE', lv: '3' },
			// 	{ levelName: 'PM', lv: '4' },
			// 	{ levelName: 'AM', lv: '5' },
			// 	{ levelName: '财务', lv: '6' },
			// 	{ levelName: '高管', lv: '7' },
			// 	{ levelName: '设计', lv: '9' },
			// 	{ levelName: '技术', lv: '10' },
			// ],
			form: {
				user_no: '',
				nickname: '',
				en_name: '',
				realname: '',
				phone: '',
				dep_id: '',
				department: {},
				position_id: '',
				position: {},
				leader: '',
				level: '',
				office_list: '',
				subordinate: [],
				leader_name: '',
				access: '',
				status: '1',
			},
			w: 469,
			h: 676,
			authorType: '',
			projectShow: false, //关联弹窗
			projectForm: {
				option: '1',
				user_id: '',
				client_id: '',
				barnd_list: [],
				brand_id: '',
				project_list: [],
				project_id: '',
				del_str: '',
			},
			deleteShow: false, // 删除弹窗
			tempDelete: {},
			clientList: [],
			brandList: [],
			projectList: [],
		}
	},
	computed: {

	},
	created() {
		this.query = this.$route.query
		this.authorType = this.query.type
		this.getDetail(this.query.id)
		this.getClientList()
	},
	mounted() {
		this.getUserList()
		this.getRoleList()
	},
	watch: {
		['form.phone'](val) {
			if (val != undefined) {
				this.$nextTick(() => {
					this.form.phone = val.replace(/\D/g, '');
				});
			}
		},
	},
	methods: {
		checkUrlFn() {
			// 获取当前URL的哈希部分  
			const hash = window.location.hash;
			// 移除'#'字符  
			const url = hash.substring(1);
			
			let postData = {
				url_path: url
			}
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({
						type: 'info',
						message: '暂无权限',
					})
					this.$router.push({
						path: `/home`
					});
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = {
				menu_id,
			}
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},
		async getUserList() {
			this.$fly
				.post('apiAccount_getUserList.html', {
					per_page: 5000,
				})
				.then((res) => {
					this.userList = res.itemList
				})
		},
		async getDepartList() {
			return new Promise((resolve) => {
				this.$fly
					.post('apiAccount_getDepartmentList.html', {

					})
					.then((res) => {
						this.departList = res
						resolve(res)
					})
			})
		},
		async getWhiteList() {
			return new Promise((resolve) => {
				this.$fly
					.post('apiProject_getWhitelist.html', {
						user_id: this.form.uid,
					})
					.then((res) => {
						this.whiteList = res?.white_project
						resolve(res)
					})
			})
		},
		async getRoleList() {
			return new Promise((resolve) => {
				this.$fly
					.post('ApiRole_getRoleList.html', {
						per_page: 5000,
					})
					.then((res) => {
						this.roleList = res
						resolve(res)
					})
			})
		},
		async getDetail(id) {
			this.checkUrlFn()
			this.checkNodeFn('61')
			api.getAccountDetail({
				uid: id,
			})
				.then((res) => {
					const {
						nickname,
						realname,
						en_name,
						user_no,
						phone,
						dep_id,
						department,
						position_id,
						position,
						subordinate,
						leader,
						leader_name,
						access,
						office_list,
						level,
						status,
					} = res.bkUserArr
					this.form = {
						uid: id || '',
						nickname,
						realname,
						en_name,
						user_no,
						phone,
						dep_id,
						department,
						position_id,
						position,
						subordinate,
						leader,
						leader_name,
						access,
						office_list,
						level,
						status,
					}
					this.getDepartList().then(() => {
						this.$fly
							.post('apiAccount_getPositionList.html', {
								department_id: dep_id
							})
							.then((res) => {
								this.positionList = res
							})
					})
					this.getWhiteList()
					return res
				})
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.addUpdateUser()
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		addUpdateUser() {
			this.form.option = this.form.uid ? '2' : '1'
			const {
				uid,
				nickname,
				phone,
				option,
			} = this.form
			const newTemp = {
				uid,
				nickname,
				phone,
				option,
			}
			if (this.authorType == '1') {//编辑职位
				api.addUpdateUser({
					...newTemp,
					level: this.form.level,
				}).then(() => {
					this.$message.success('success')
					this.$router.go(-1)
				})
			}
			else if (this.authorType == '2') {//查阅范围
				api.addUpdateUser({
					...newTemp,
					access: this.form.access,
				}).then(() => {
					this.$message.success('success')
					this.$router.go(-1)
				})
			}
			else if (this.authorType == '3') {//直属上下级
				api.addUpdateUser({
					...newTemp,
					leader: this.form.leader,
				}).then(() => {
					this.$message.success('success')
					this.$router.go(-1)
				})
			}
			else if (this.authorType == '4') {//办公用品
				api.addUpdateUser({
					...newTemp,
					office_list: this.form.office_list,
				}).then(() => {
					this.$message.success('success')
					this.$router.go(-1)
				})
			}
			else {
				this.$message.success('请返回上一个页面重试')
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.$router.go(-1)
		},
		toPersonFn(id) {
			this.$router.push({
				path: '/author/view',
				query: { id: id },
			})
		},
		showProject() {
			this.projectForm = {
				option: '1',
				user_id: this.form.uid,
				client_id: '',
				// barnd_list: [],
				brand_id: '',
				// project_list: [],
				project_id: '',
				del_str: '',
			},
				this.projectShow = true
		},
		getClientList(client_id, brand) {
			this.$fly.post('apiSale_getClientBrandList.html', {
				client_id,
				brand,
			}).then((res) => {
				if (!client_id && !brand) {
					this.clientList = res
				}
				else if (client_id && !brand) {
					this.brandList = res.length ? res : false
				}
				else if (client_id && brand) {
					this.projectList = res.length ? res : false
					console.log(this.projectList);
				}
			})
		},
		clientChange(v) {
			this.projectForm.client_id = v
			this.getClientList(v)
			//清空品牌列表和所选品牌
			this.brandList = []
			this.projectForm.barnd_list = []
			this.projectForm.brand_id = ''
			//清空项目列表和所选项目
			this.projectList = []
			this.projectForm.project_list = []
			this.projectForm.project_id = ''
			this.$forceUpdate()
		},
		brandChange(v) {
			const client_id = this.projectForm.client_id
			const brand = v.toString()
			this.projectForm.brand_id = brand
			this.getClientList(client_id, brand)
			//清空项目列表和所选项目
			this.projectList = []
			this.projectForm.project_list = []
			this.projectForm.project_id = ''
			this.$forceUpdate()
		},
		projectChange(v) {
			const project = v.toString()
			this.projectForm.project_id = project
			this.$forceUpdate()
		},
		cancelProjectId() {
			this.projectShow = false
		},
		confirmProjectId() {
			const tempForm = JSON.parse(JSON.stringify(this.projectForm))
			delete tempForm.barnd_list
			delete tempForm.project_list
			if (tempForm.project_id) {
				delete tempForm.brand_id
				delete tempForm.client_id
			}
			else if (tempForm.brand_id) {
				delete tempForm.client_id
			}
			this.$fly.post('apiProject_addOrUpdateWhitelist.html', {
				...tempForm,
			}).then((res) => {
				if (res.status == 200) {
					//确认完毕关闭弹窗清空临时form
					this.projectShow = false
					this.getDetail(this.query.id)
				}
				else {
					this.$message.error(res.message)
				}
			})
		},
		deleteWhite(id, type, str) {
			this.tempDelete = {
				user_id: this.form.uid,
				del_str: id,
				type,
				ncbn_str: str,
			}
			this.deleteShow = true
		},
		handleDelete() {
			this.$fly.post('apiProject_delWhitelist.html', {
				...this.tempDelete
			}).then((res) => {
				if (res.status == 200) {
					this.deleteShow = false
					this.getDetail(this.query.id)
				}
				else {
					this.$message.error(res.message)
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.header {
	//标题样式
	@extend %box;
	box-sizing: border-box;
	width: 100%;
	background: #fff;
	padding: 20px 40px;
	margin-bottom: 10px;
	@extend %center;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: flex-start;

	.header-info {
		width: 80%;
		@extend %center;
		align-items: flex-start;
		text-align: left;

		h1 {
			font: 700 28px/1 $font;
			margin-bottom: 16px;
		}

		p {
			font: 16px/2 $font;
		}
	}

	.header-status {
		@extend %center;
		flex-flow: row nowrap;

		.button {
			box-sizing: border-box;
			min-width: 100px;
			border-radius: 20px;
			padding: 10px 15px;
			font: 12px/1 $font;
			color: #fff;
		}
	}
}

.userdetail {
	.history {
		@extend %box;
		padding: 30px 40px;
	}

	.base1 {
		@extend %box;
		margin-bottom: 20px;
		padding: 30px 40px;
		position: relative;

		>ul {
			@extend %start;
			color: #231f20;
			background: #f2f2f2;
			padding: 0 25px;
			border-radius: 20px;
			margin-bottom: 20px;
			position: relative;

			&:last-of-type {
				margin-bottom: 0;
			}

			li {
				width: 50%;
				font: 14px/3 $font;

				p {
					min-height: 42px;
					padding: 5px 0;
					@extend %start;

					label {
						width: 150px;
						white-space: nowrap;
						flex: none;
					}


				}
			}
		}
	}

	.authorlist {
		width: 100%;
		padding: 5px 0 0;
		flex-flow: column nowrap;

		li {
			width: auto;
			position: relative;
			margin-bottom: 15px;

			&:last-of-type {
				margin-bottom: 32px;
			}

			.subbtn {
				width: 240px;
				height: 32px;
				line-height: 32px;
				background: #0E0F22;
				color: #fff;
				text-align: center;
				cursor: pointer;

				&:hover {
					background: rgba($color: #0E0F22, $alpha: 0.8);
				}
			}

		}
	}
}

.switch {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}

.el-switch {
	font: 14px/20px $font;

	&.cursor {
		cursor: not-allowed;

		.el-switch__core {
			background-color: #999888;
			border-color: #999888;
			cursor: not-allowed;
		}
	}

	&.is-checked {
		cursor: not-allowed;

		&.super {
			.el-switch__core {
				cursor: pointer;
				background-color: #0E0F22;
				border-color: #0E0F22;

				&::before {
					font: 14px/20px $font;
					content: '是';
				}
			}
		}

		.el-switch__core {
			cursor: not-allowed;
			background-color: #999888;
			border-color: #999888;

			&::before {
				font: 14px/20px $font;
				content: '是';
			}
		}
	}

	.el-switch__core {
		background-color: #0E0F22;
		border-color: #0E0F22;

		&::before {
			font: 14px/20px $font;
			content: '否';
		}

		&::after {
			content: '';
		}
	}
}

.operater {
	@extend %start;
	position: absolute;
	top: 30px;
	right: 40px;
	font: 14px/1 $font;
	text-align: center;

	>div {
		min-width: 32px;
		border: 1px solid #DCDFE6;
		border-radius: 3px;
		padding: 9px 10px;
		cursor: pointer;

		&.linkline {
			border-color: transparent;
			background: transparent;
			color: #231f20;

			&:hover {
				&::after {
					display: block;
					content: '';
					height: 0.1px;
					background: #231f20;
				}
			}
		}

		&.linkbox {
			border-color: #0E0F22;
			background: #0E0F22;
			color: #fff;

			&.grey {
				border-color: #c0c4cc;
				background: #c0c4cc;
				color: #fff !important;

				&:hover {
					background: #c0c4cc;
				}
			}

			&:hover {
				background: rgba($color: #0E0F22, $alpha: 0.8);
			}
		}
	}
}

.whitelist {
	height: 32px;
	margin-bottom: 32px;
	@extend %start;

	&:last-of-type {
		margin-bottom: 0;
	}

	.whitelist_del {
		display: none;
		margin-left: 40px;
	}

	&:hover {
		.whitelist_del {
			display: inline-block;
		}
	}
}
</style>